export let Code = {
type: `@Component({
    selector: 'p-growl',
    template:
       <p-growl [(value)]="msgs"></p-growl>
        <h3 class="first">Basic</h3>
        <div>
            <button type="button" pButton (click)="showSuccess()" label="Success" class="ui-button-success"></button>
            <button type="button" pButton (click)="showInfo()" label="Info" class="ui-button-info"></button>
            <button type="button" pButton (click)="showWarn()" label="Warn" class="ui-button-warning"></button>
            <button type="button" pButton (click)="showError()" label="Error" class="ui-button-danger"></button>
            <button type="button" pButton (click)="showMultiple()" label="Multiple"></button>
            <button type="button" pButton (click)="clear()" icon="ion-close-round" style="float:right" label="Clear"></button>
        </div>

        <h3>Message Service</h3>
        <div>
            <button type="button" pButton (click)="showViaService()" label="Add with Service"></button>
            <button type="button" pButton (click)="clearViaService()" label="Clear with Service"></button>
        </div>
})
export class Growl {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/growl.ts